import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { z } from 'zod';

export const pharmacyLabsDiscussionsRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/labs_discussions',
  validateSearch: z.object({
    search: z.string().optional(),
  }),
}).lazy(() =>
  import('pages/pharmacy/SalesRepDiscussions/SalesRepDiscussionsPage/SalesRepDiscussionsPage').then(
    (d) => d.Route
  )
);
